import css from './songs.module.scss';
import {useEffect, useState} from 'react';
import {DndContext, closestCenter, DragEndEvent} from '@dnd-kit/core';
import {arrayMove, SortableContext, verticalListSortingStrategy} from '@dnd-kit/sortable';
import {restrictToParentElement, restrictToVerticalAxis} from '@dnd-kit/modifiers';
import {SongsProps} from './songs.types';
import {SortableItem} from './sortable-item/sortable-item';
import {setOrder} from '../../pages/setlist/setlist.slice';
import {useDispatch} from 'react-redux';

export const Songs = ({draggable, list}: SongsProps) => {
	const dispatch = useDispatch();
	const indexList = list.map((item) => Number(item.index));
	const [items, setItems] = useState(indexList);

	useEffect(() => {
		dispatch(setOrder(items));
	}, [items]);

	const handleDragEnd = (event: DragEndEvent) => {
		const {active, over} = event;

		if (active.id !== over?.id) {
			setItems((items) => {
				const oldIndex = items.indexOf(active?.id as number);
				const newIndex = items.indexOf(over?.id as number);
				return arrayMove(items, oldIndex, newIndex);
			});
		}
	};

	return (
		<DndContext
			onDragEnd={handleDragEnd}
			collisionDetection={closestCenter}
			modifiers={[restrictToParentElement, restrictToVerticalAxis]}
		>
			<SortableContext items={items} strategy={verticalListSortingStrategy}>
				<div className={css.container}>
					{items.map((id) => (
						<SortableItem draggable={draggable} song={list[id - 1]} key={id} id={id} />
					))}
				</div>
			</SortableContext>
		</DndContext>
	);
};
